// WelcomeMarquee — global, fixed, infinitely-scrolling welcome bar.
//
// Sits directly under the main Header (top: 36 + 80 = 116px, height 40px)
// and above every hero section. Reuses the same visual language as the
// hotel-card `MarqueeRibbon` (dark background, cream tracking-wide
// uppercase text, gold Amazigh-diamond separators between phrases,
// duplicated track for seamless infinite loop). Rendered once at the
// Layout level so it appears on every public page without duplication.

import React from "react";
import MarqueeRibbon from "@/components/MarqueeRibbon";

// Welcome greetings in fifteen of the world's most widely spoken
// languages. Kept as a static constant so React can freeze the array
// reference and MarqueeRibbon's `useMemo(phrases)` never re-runs.
const WELCOME_PHRASES = Object.freeze([
  "Welcome",
  "欢迎",
  "नमस्ते",
  "Hola",
  "أهلاً وسهلاً",
  "Bonjour",
  "Olá",
  "Здравствуйте",
  "সালাম",
  "Salam",
  "ようこそ",
  "Benvenuto",
  "Willkommen",
  "Hoş geldiniz",
  "환영합니다",
]);

const WelcomeMarquee = () => (
  <MarqueeRibbon
    phrases={WELCOME_PHRASES}
    speed={45}
    testIdPrefix="welcome-marquee"
  />
);

export default WelcomeMarquee;
